import type { PublicOffering } from './domain'

/** Only guest-facing metadata; operator SKU/product bindings never reach this view. */
export function OfferingContext({ offering }: { offering: Pick<PublicOffering, 'discoveryTag' | 'campaignTag' | 'outdoor' | 'sameBusinessLocation' | 'addressOverride' | 'address2'> }) {
  const tags = [offering.discoveryTag, offering.campaignTag, offering.outdoor ? 'Outdoors' : undefined].filter(Boolean)
  const location = [offering.sameBusinessLocation === false ? offering.addressOverride : undefined, offering.address2].filter(Boolean).join(' · ')
  if (!tags.length && !location) return null
  return <div className="offering-context">{tags.length ? <p>{tags.join(' · ')}</p> : null}{location ? <p><strong>{offering.sameBusinessLocation === false ? 'Experience location' : 'Arrival details'}:</strong> {location}</p> : null}</div>
}
